import React from 'react';
import { Card } from 'react-bootstrap';

import { useTranslation } from '../../common/hooks/useTranslation';

import { InfoToggle } from './InfoToggle';

interface CardTitleWithInfoProps {
  title: React.ReactNode;
  children: React.ReactNode;
}

export const CardTitleWithInfo: React.FC<CardTitleWithInfoProps> = ({
  title,
  children,
}) => {
  const { t, tk } = useTranslation('commonLng');

  return (
    <div className="d-flex flex-wrap align-items-center pb-3 gap-2">
      <Card.Title className="mb-0 me-auto">{title}</Card.Title>
      <InfoToggle title={t(tk.common.instructions)}>{children}</InfoToggle>
    </div>
  );
};
